import { ILedger, ILedgerParams, ITableRes } from 'types'
import { baseApi } from './baseApi'

export const ledgerAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_ledger: builder.query<ITableRes<ILedger>, ILedgerParams>({
      query: (params) => ({
        url: '/ledger/',
        params,
      }),
      providesTags: ['ledger'],
    }),
  }),
})

export const { useGET_ledgerQuery } = ledgerAPI
